import swal from "sweetalert";
import axiosInstance from './AxiosInstance';
export function formatError(errorResponse) {
    switch (errorResponse.message) {
        case 'EMAIL_EXISTS':
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';
            
        case errorResponse.message:
            swal("Oops", errorResponse.message, "error",{ button: "Try Again!",});
            break;

        default:
            return '';
    }
}
export function getUserProfile() {
    return axiosInstance.get(`/auth/profile`);
}

export function postUserProfile(data) {
    return axiosInstance.post(`/auth/profile`, data);
}

export function changePassword(data) {
    // Backend should expose /users/change-password as per API contract.
    return axiosInstance.post(`/auth/change-password`, data);
}